import { render, staticRenderFns } from "./ProxyRouter.vue?vue&type=template&id=0f8349c5&"
import script from "./ProxyRouter.vue?vue&type=script&lang=js&"
export * from "./ProxyRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports